import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["dialog", "list"]
    open() { this.original = this.listTarget.innerHTML; this.dialogTarget.showModal() }
    close() { this.dialogTarget.close(); this.listTarget.innerHTML = this.original }
    cancel(event) { event.preventDefault(); this.close() }
    disconnect() { this.dialogTarget.close() }
    start(event) {
        this.dragging = event.target.closest("[data-section]")
        event.dataTransfer.effectAllowed = "move"
        event.dataTransfer.setData("text/plain", this.dragging.dataset.section)
    }
    over(event) {
        const row = event.target.closest("[data-section]")
        if (!row || !this.dragging || row === this.dragging) return
        event.preventDefault()
        const before = event.clientY < row.getBoundingClientRect().top + row.offsetHeight / 2
        row.parentNode.insertBefore(this.dragging, before ? row : row.nextSibling)
    }
    drop(event) { event.preventDefault(); this.end() }
    end() { this.dragging = null }
    up(event) {
        const row = event.currentTarget.closest("[data-section]")
        if (row.previousElementSibling) row.parentNode.insertBefore(row, row.previousElementSibling)
        event.currentTarget.focus()
    }
    down(event) {
        const row = event.currentTarget.closest("[data-section]")
        if (row.nextElementSibling) row.parentNode.insertBefore(row.nextElementSibling, row)
        event.currentTarget.focus()
    }
}
